import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Instagram, Handshake, ArrowRight } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { api, waLink, mapEmbed } from "../lib/constants";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle, GoldButton, OutlineButton } from "../components/site/Primitives";
import SEO from "../components/SEO";

const PROTESE_ROUTE = { arapiraca: "/protese-capilar-arapiraca", garanhuns: "/protese-capilar-garanhuns", maceio: "/protese-capilar-maceio" };

export default function Unidades() {
  const { site } = useSite();
  const [units, setUnits] = useState([]);
  useEffect(() => {
    api.get("/units").then(({ data }) => setUnits(data)).catch(() => {});
  }, []);

  return (
    <div>
      <SEO title="Unidades e Locais de Atendimento | Arapiraca, Garanhuns e Maceió" description="Barbearia das Estrelas em Arapiraca, Prime Capilar Clinic em Garanhuns e atendimento de prótese em Maceió em parceria com a Arena Barbearia." />

      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Onde estamos</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle>Unidades e locais de atendimento</SectionTitle></Reveal>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20 space-y-20">
        {units.map((unit, idx) => (
          <Reveal key={unit.id}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center" data-testid={`unidade-${unit.slug}`}>
              <div className={idx % 2 === 1 ? "lg:order-2" : ""}>
                {unit.partner && (
                  <span className="inline-flex items-center gap-2 bg-gold text-black font-heading font-600 text-[11px] tracking-widest px-3.5 py-1.5 rounded-sm mb-4">
                    <Handshake className="w-3.5 h-3.5" /> PARCEIRO PARA ATENDIMENTO DE PRÓTESE CAPILAR
                  </span>
                )}
                <Overline className="mb-2">{unit.city}, {unit.state}</Overline>
                <h2 className="font-heading font-700 uppercase text-3xl lg:text-4xl text-white tracking-tight">{unit.name}</h2>
                <p className="mt-3 text-zinc-400 leading-relaxed">{unit.tagline}.</p>
                {unit.partner && (
                  <p className="mt-3 text-sm text-zinc-500">Atendimento em parceria com a Arena Barbearia. A Arena Barbearia é uma empresa parceira — não é uma filial própria.</p>
                )}

                <div className="mt-6 flex flex-wrap gap-2">
                  {(unit.services || []).map((s) => (
                    <span key={s} className="border border-white/12 rounded-sm px-3 py-1.5 text-xs text-zinc-300">{s}</span>
                  ))}
                </div>

                <div className="mt-6 space-y-2.5 text-sm text-zinc-300">
                  <p className="flex items-center gap-2.5"><MapPin className="w-4 h-4 text-gold" /> {unit.address}</p>
                  <p className="flex items-center gap-2.5"><Clock className="w-4 h-4 text-gold" /> {unit.hours}</p>
                  {unit.instagram && <a href={unit.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 hover:text-gold transition-colors"><Instagram className="w-4 h-4 text-gold" /> Instagram</a>}
                </div>

                <div className="mt-7 flex flex-wrap gap-3">
                  {unit.type === "barbearia" && <GoldButton href={waLink(site, "barbearia")}>AGENDAR NA BARBEARIA</GoldButton>}
                  <OutlineButton href={waLink(site, unit.wa_key)}>FALAR NO WHATSAPP</OutlineButton>
                  <Link to={PROTESE_ROUTE[unit.slug]} className="inline-flex items-center gap-2 text-gold hover:text-gold-hover font-heading font-600 text-sm tracking-wide px-2 py-3 transition-colors">
                    Página de prótese <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>

              <div className={`space-y-4 ${idx % 2 === 1 ? "lg:order-1" : ""}`}>
                <div className="aspect-[16/10] overflow-hidden rounded-sm border border-white/10">
                  <iframe title={`Mapa ${unit.city}`} src={mapEmbed(unit.map_query)} className="w-full h-full" style={{ border: 0 }} loading="lazy" />
                </div>
                <div className="grid grid-cols-3 gap-3">
                  {(unit.photos || []).slice(0, 3).map((p, i) => (
                    <div key={i} className="aspect-square overflow-hidden rounded-sm border border-white/10">
                      <img src={p} alt="" className="w-full h-full object-cover" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
